// RegionModelWindow.js

import React, { Component } from "react";
import { connect } from "react-redux";
import { regEditerAction, changeBoringID1Action, changeBoringID2Action, updateWLTrAction, updatePompTrAction, changeselMeaRowAction, updateScreenTrAction } from "../../redux/editer/actions";
import { changeSwModeAction, changeEditerModeAction, changeInPredictAction, finLrnAction, changeInExeWaitngAction, changeWaitngTimeAction } from "../../redux/app/actions";
import { updateWellsTrAction, changeNewDsAction, changeWsSelRowAction, changeCheckPreIndAction } from "../../redux/boring/actions";
import { openEditerAction, openEstBoringAction, showInputTempWindowAction, showDetailEditerWindowAction } from "../../redux/ui/actions";
import { changeRegionAction, changeCoordAction } from "../../redux/modelArea/actions";
import EstBoring from "../EstBoring";
import Sw from "../common/Sw";
import Main from "./Main";
const mapStateToProps = state => {
  return {
    wellsTrData: state.boringReducer.wellsTrData,
    boringID1: state.editerReducer.boringID1,
    boringID2: state.editerReducer.boringID2,
    newDs: state.boringReducer.newDs,
    boringDs: state.boringReducer.dataset,
    estBorSw: state.uiReducer.estBorSw,
    paramRegion: state.paramReducer.region,
    crossValid: state.boringReducer.crossValid,
    modelKind: state.boringReducer.modelKind,
    wsSelRow: state.boringReducer.wsSelRow,
    wlTrData: state.editerReducer.editerWlMeaData,
    pompTrData: state.editerReducer.editerPompMeaData,
    detailCat: state.editerReducer.detailCat,
    scrTrData: state.editerReducer.editerScreenData,
  };
};

class RegionModelWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      highlightedRow: null,
      selectedCheckbox: null,
    };
    this.changeRow = this.changeRow.bind(this);
    this.changeType = this.changeType.bind(this);
    this.changeField = this.changeField.bind(this);
    this.checkField = this.checkField.bind(this);
    this.doLearnPred = this.doLearnPred.bind(this);
    this.deleteAll = this.deleteAll.bind(this);
    this.hglBoring = this.hglBoring.bind(this);
    this.deleteSel = this.deleteSel.bind(this);
    this.addSel = this.addSel.bind(this);
  }

  /*
   * 地域変更
   * @since hara 2021-03-23
   */
  async changeRegion(key) {
    const origin = window.location.origin;
    const search = window.location.search;
    const value = key;
    //this.showRegion(value,false);
    this.props.dispatch(changeRegionAction(value));
    let hyperParamID = value;

    //選択したハイパーパラメータのIDをDBに登録

    await fetch(`${origin}/api/user/0/hyperparam/${hyperParamID}/${search}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(res => res.json())
      .catch(err => console.log(err));

    //地域レンジ内のボーリングを格納
    //window.registerAreaBoring(this.props, key)
  }

  changeRow = e => {
    e.target.closest("tbody").childNodes.forEach(el => {
      el.classList.remove("selRow");
    });
    const tr = e.target.closest("tr");
    tr.classList.add("selRow");
    this.props.dispatch(changeWsSelRowAction(tr.id));
    console.log(`Row ${tr.id} clicked!`);
  };

  changeField = (e, index, field) => {
    const latRange = [20, 46];
    const lonRange = [122, 154];

    const rawValue = e.target.value;
    const value = Number(rawValue);

    // ---- 数値チェック ----
    if (field === "PA" || field === "LAT" || field === "LON") {
      if (isNaN(value)) {
        alert("数値を入力してください。");
        return;
      }
    }

    // ---- 予測データ確認 ----
    const hasPreData = this.props.wellsTrData[index].PREDATA !== undefined;

    if ((field === "LAT" || field === "LON") && hasPreData) {
      const answer = window.confirm("井戸位置を変更する場合、予測結果が削除されます。");
      if (!answer) return;
    }

    // ---- 更新処理 ----
    const updatedWellsTrData = this.props.wellsTrData.map((el, i) => {
      if (i === index) {
        return {
          ...el,
          [field]: rawValue,
          ...(field === "LAT" || field === "LON"
            ? { PREDATA: undefined } // 緯度経度変更時は削除
            : {}),
        };
      }
      return el;
    });

    this.props.dispatch(updateWellsTrAction(updatedWellsTrData));
  };

  checkField = (e, index, field, lonLat) => {
    let latRange = [20, 46];
    let lonRange = [122, 154];
    const changeField = Number(window.formatNumber(e.target.value));
    switch (field) {
      case "LAT":
        //if (!(changeField >= latRange[0] && changeField <= latRange[1])) {
        //  alert("緯度" + "は" + latRange[0] + "以上、" + latRange[1] + "以下で入力してください。");
        //  return;
        //}
        window.updateWellLocationById(index, lonLat, changeField);
        break;
      case "LON":
        //if (!(changeField >= lonRange[0] && changeField <= lonRange[1])) {
        //  alert("経度" + "は" + lonRange[0] + "以上、" + lonRange[1] + "以下で入力してください。");
        //  return;
        // }
        window.updateWellLocationById(index, changeField, lonLat);
        break;
    }
    const updatedWellsTrData = this.props.wellsTrData.map((el, i) => {
      if (i === index) {
        return { ...el, [field]: changeField };
      }
      return el;
    });
    console.log(updatedWellsTrData);
    // 新しい wellsTrData をセット
    this.props.dispatch(updateWellsTrAction(updatedWellsTrData));
  };

  /*
   * ボーリングハイライト
   * @param {String} ID1 ボーリングID1
   * @param {String} ID2 ボーリングID2
   * @since hara 2020-09-09
   */
  hglBoring(ID1) {
    if (ID1 !== null) {
      window.hglWellsBoring(ID1);
    } else {
      window.dehglBoring();
    }
  }

  handleCheckboxClick = index => {
    this.setState(prevState => ({
      selectedCheckbox: prevState.selectedCheckbox === index ? null : index,
    }));

    // その後の処理
    if (this.state.selectedCheckbox !== index) {
      if (this.props.wellsTrData[index].PREDATA == undefined) {
        this.setState({ selectedCheckbox: null });
        alert("予測実行してください。");
      } else {
        // チェックがついている場合の処理
        this.props.dispatch(showInputTempWindowAction(false));
        this.props.dispatch(changeCheckPreIndAction(index));
        this.props.dispatch(showDetailEditerWindowAction(false));
        this.props.dispatch(changeNewDsAction(this.props.boringDs));
        this.props.dispatch(openEstBoringAction(Math.random()));
      }
    } else {
      // チェックが外された場合の処理
      this.props.dispatch(showInputTempWindowAction(false));
      this.props.dispatch(openEstBoringAction(null));
    }
  };

  deleteAll() {
    this.props.dispatch(updateWellsTrAction([]));
    this.props.dispatch(openEstBoringAction(null));
    //紐付いている詳細情報も削除する
    // wellsTrData の更新
    if (this.props.wlTrData[1000]) {
      const updatedWLTrData = {
        ...this.props.wlTrData,
        [1000]: {},
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateWLTrAction(updatedWLTrData));
    }

    if (this.props.pompTrData[1000]) {
      const updatedPompTrData = {
        ...this.props.pompTrData,
        [1000]: {},
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updatePompTrAction(updatedPompTrData));
    }

    if (this.props.scrTrData[1000]) {
      const updatedScrTrData2 = {
        ...this.props.scrTrData,
        [1000]: {},
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateScreenTrAction(updatedScrTrData2));
    }
    this.setState({ selectedCheckbox: null });
    window.removeWellsData();
  }

  /*
   * 行追加
   * @since ando 2024-03-27
   */
  addSel() {
    const newRow = {
      ID: 0, // 後で振り直す
      LAT: 0,
      LON: 0,
      KIND: "type1",
      PA: 0,
      IT: [],
    };

    // wellsTrData に追加
    const updatedWellsTrData = [...this.props.wellsTrData, newRow];

    // IDを振り直す
    const updatedWellsTrDataWithNewIds = updatedWellsTrData.map((el, i) => ({
      ...el,
      ID: i + 1,
    }));

    // Redux更新
    this.props.dispatch(updateWellsTrAction(updatedWellsTrDataWithNewIds));

    // 追加された行のindex
    const newIndex = updatedWellsTrDataWithNewIds.length - 1;

    // 紐づく詳細データも追加
    if (this.props.wlTrData[1000]) {
      const updatedWLTrData = {
        ...this.props.wlTrData,
        [1000]: {
          ...this.props.wlTrData[1000],
          [newIndex]: [], // 空配列で初期化
        },
      };
      this.props.dispatch(updateWLTrAction(updatedWLTrData));
    }

    if (this.props.pompTrData[1000]) {
      const updatedPompTrData = {
        ...this.props.pompTrData,
        [1000]: {
          ...this.props.pompTrData[1000],
          [newIndex]: [],
        },
      };
      this.props.dispatch(updatePompTrAction(updatedPompTrData));
    }

    if (this.props.scrTrData[1000]) {
      const updatedScrTrData = {
        ...this.props.scrTrData,
        [1000]: {
          ...this.props.scrTrData[1000],
          [newIndex]: [],
        },
      };
      this.props.dispatch(updateScreenTrAction(updatedScrTrData));
    }
    window.drawWellsPoint(0, 0);
  }

  /*
   * 行削除
   * @since ando 2024-03-27
   */
  deleteSel() {
    // 指定されたインデックスの行を除外して新しい wellsTrData 配列を作成する
    const updatedWellsTrData = this.props.wellsTrData.filter((el, i) => i != this.props.wsSelRow);

    const updatedWellsTrDataWithNewIds = updatedWellsTrData.map((el, i) => ({
      ...el,
      ID: i + 1, // 新しいidを振り直す
    }));

    //ポイントを削除する。
    window.removeWellsPointData(parseInt(this.props.wsSelRow) + 1);
    this.props.dispatch(openEstBoringAction(null));
    // 新しい wellsTrData をセット
    this.props.dispatch(updateWellsTrAction(updatedWellsTrDataWithNewIds));

    //紐付いている詳細情報も削除する
    // wellsTrData の更新
    if (this.props.wlTrData[1000]) {
      const updatedWLTrData = {
        ...this.props.wlTrData,
        [1000]: {
          ...this.props.wlTrData[1000],
          [this.props.wsSelRow]: [],
        },
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateWLTrAction(updatedWLTrData));
    }
    if (this.props.pompTrData[1000]) {
      const updatedPompTrData = {
        ...this.props.pompTrData,
        [1000]: {
          ...this.props.pompTrData[1000],
          [this.props.wsSelRow]: [],
        },
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updatePompTrAction(updatedPompTrData));
    }
    if (this.props.scrTrData[1000]) {
      const updatedScrTrData2 = {
        ...this.props.scrTrData,
        [1000]: {
          ...this.props.scrTrData[1000],
          [this.props.wsSelRow]: [],
        },
      };
      // 新しい wellsTrData をセット
      this.props.dispatch(updateScreenTrAction(updatedScrTrData2));
    }
  }

  changeType = (e, index) => {
    const selectedType = e.target.value;

    // State を変更する場合は、this.setState を使用する
    // この例では新しい wellsTrData 配列を作成して setState する
    const updatedWellsTrData = this.props.wellsTrData.map((el, i) => {
      if (i === index) {
        window.setFillColorForFeature(i + 1, selectedType);
        return { ...el, KIND: selectedType };
      }
      return el;
    });
    console.log(updatedWellsTrData);
    // 新しい wellsTrData をセット
    this.props.dispatch(updateWellsTrAction(updatedWellsTrData));
  };
  /*
   * 表示/非表示を切り替える
   * @since ando 2023-08-08
   */
  cheakArea() {
    return true;
    let keys = 0;
    //クリック位置からエリアを特定
    for (let key in this.props.paramRegion) {
      const coord = this.props.paramRegion[key].range;
      if (this.props.modelKind == 3) {
        if (coord["x1"] < window.getWellsPoint()[0] && coord["y1"] < window.getWellsPoint()[1] && coord["x2"] > window.getWellsPoint()[0] && coord["y2"] > window.getWellsPoint()[1]) {
          keys = key;
        }
      } else {
        if (coord["x1"] < window.getCP()[0] && coord["y1"] < window.getCP()[1] && coord["x2"] > window.getCP()[0] && coord["y2"] > window.getCP()[1]) {
          keys = key;
        }
      }
    }
    this.changeRegion(keys);
    if (keys != 0) {
      return true;
    } else {
      return false;
    }
  }

  /*
   * ボーリング数チェック
   * @param {Event} e イベント情報
   * @since ando 2023-08-07
   */
  checkBoringNum() {
    let num = window.cntAreaBoring(window.getmodelAreaCoord()[0], window.getmodelAreaCoord()[1], window.getmodelAreaCoord()[2], window.getmodelAreaCoord()[3]);
    console.log(num);
    if (num < 1) {
      return false;
    } else {
      return true;
    }
  }

  /*
   * 学習予測
   * @since ando 2023-08-07
   */
  async doLearnPred() {
    await this.doCheckExe();
    //入力データをチェック
    //学習領域内のボーリング数をチェック
    if (this.cheakArea()) {
      if (this.checkBoringNum()) {
        if (this.props.wellsTrData.length > 0) {
          await this.doLearn(true);
        }
        //if (window.existModelArea()) {

        //} else {
        //  alert('学習領域を作成してください。');
        //}
      } else {
        alert("学習領域内のボーリングが不足しています。");
      }
    } else {
      alert("井戸位置を指定してください。");
    }
  }

  /*
   * 推定実行
   * @since kawai 2020-09-09
   */
  async doLearn(pred) {
    /*
     * 入力値確認
     */
    let useChk = true;
    this.props.boringDs.forEach(el => {
      if (el.use) useChk = false;
    });
    if (useChk) {
      alert("推定に使用するボーリングデータセットを1つ以上選択してください。");
      return;
    }
    if (this.props.modelDep < 1 || 1000 < this.props.modelDep) {
      alert("モデル深度は 1~1000 の範囲で設定してください。");
      return;
    }

    /*
     * 推定
     */
    const waiting = stat => {
      this.props.dispatch(changeInPredictAction(stat));
    };
    waiting(true);

    //チェックされたボーリングの情報を取得
    //boringDsのuseプロパティを使用するよう修正 @since hara 2020-10-08
    let selectedBoring = [];
    this.props.boringDs.forEach(el => {
      if (el.use) {
        selectedBoring.push({
          ID: el["ID"],
          name: el["name"],
        });
      }
    });
    const origin = window.location.origin;
    const search = window.location.search;
    //サーバへ指定したボーリングを使用して学習を行うように要求
    await fetch(`${origin}/api/user/0/model/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        selectedBoring: selectedBoring,
        //モデル領域機能で選択した領域でモデルを作成する
        range: {
          x1: window.getmodelAreaCoord()[2],
          x2: window.getmodelAreaCoord()[3],
          y1: window.getmodelAreaCoord()[1],
          y2: window.getmodelAreaCoord()[0],
          rp: this.props.crossValid == 0 ? "none" : window.getModelMarkerNearPoint(),
          mk: this.props.modelKind == undefined ? null : this.props.modelKind,
          wells: this.props.modelKind == 3 ? this.props.wellsTrData : null,
          exe: "learnPredict",
        },
      }),
    })
      .then(res => res.json())
      .then(res => {
        if (res.result == "limit") {
          alert("現在サーバーが混み合っております。時間を空けて再度お試しください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (res.result == "outside") {
          alert("対応範囲外です。お手数ですが、位置を変更し再実行してください。");
          this.waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (JSON.parse(res).result == "timeout") {
          alert("タイムアウトエラーが発生しました。選択しているボーリング数を減らし、再度お試しください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (res.result == "fetcherror") {
          alert("サーバー内部エラーが発生しました。システム管理者に確認してくだい。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else {
          if (!pred) {
            this.linkGM();
          } else {
            this.doPredict();
          }
          //予測位置サブウィンドウを開けるようにする
          this.props.dispatch(finLrnAction(true));
        }
      })
      .catch(err => {
        console.log(err);
        alert("サーバーエラー");
        waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      });
  }

  /*
   * 予測実行
   * @since kawai 2020-09-15
   */
  async doPredict() {
    const waiting = stat => {
      this.props.dispatch(changeInPredictAction(stat));
    };
    const origin = window.location.origin;
    const search = window.location.search;
    fetch(`${origin}/api/0/predict/${search}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        point: this.props.modelKind == 3 ? this.props.wellsTrData : null,
        type: "wells",
        range: {
          x1: window.getmodelAreaCoord()[2],
          x2: window.getmodelAreaCoord()[3],
          y1: window.getmodelAreaCoord()[1],
          y2: window.getmodelAreaCoord()[0],
        },
        exe: "learnPredict",
      }),
    })
      .then(response => response.json())
      .then(results => {
        if (results.result == "error") {
          alert("実行エラー。時間を空けて再度お試しください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else if (results.result == "timeout") {
          alert("タイムアウトエラーが発生しました。選択しているボーリング数を減らし、再度お試しください。");
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        } else {
          this.regAnalysisBoring(results.data);
          waiting(false);
          this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
        }
      })
      .catch(err => {
        console.log(err);
        alert("サーバーエラー。");
        waiting(false);
        this.props.dispatch(changeInExeWaitngAction(false)); // GUI表示
      });
  }

  /*
   * 推定ボーリング登録
   * @since ando 2023-08-19
   */
  regAnalysisBoring(result) {
    // State を変更する場合は、this.setState を使用する
    // この例では新しい wellsTrData 配列を作成して setState する
    const updatedWellsTrData = this.props.wellsTrData.map((el, i) => {
      let vis = true;
      let use = true;
      let zIndex = 1;
      let formData = this.props.formData;
      let preData = {
        ID: this.props.regNum + 1,
        name: "Analysis",
        cat: parseInt(this.props.cat),
        geoInfo: this.props.geoInfo,
        coordSystem: this.props.coordSystem,
        color: "#ffffff",
        vis: vis,
        use: use,
        zIndex: zIndex,
        file: this.props.file,
        XAttr: result[i]["lon"],
        YAttr: result[i]["lat"],
        depThkRdo: this.props.depThkRdo,
        ZAttr: this.props.ZAttr,
        geo: result[i]["geo"],
        pID: this.props.ID,
        GLChk: this.props.GLChk,
        GL: result[i]["GL"],
        WLChk: this.props.WLChk,
        WL: result[i]["WL"],
        headerNum: this.props.headerNum,
        fieldNameChk: this.props.fieldNameChk,
        csvData: this.props.csvData,
        newData: this.props.newData,
        formData: formData,
        userData: this.props.userData,
        lat: result[i]["lat"],
        lon: result[i]["lon"],
        screen: result[i]["screen"],
        ido_ID: result[i]["ido_ID"],
      };
      return { ...el, PREDATA: preData };
    });
    console.log(updatedWellsTrData);
    // 新しい wellsTrData をセット
    this.props.dispatch(updateWellsTrAction(updatedWellsTrData));
  }

  /*
   * 実行可否を確認
   * @since ando 2025-07-31
   */
  async doCheckExe() {
    const origin = window.location.origin;
    const search = window.location.search;

    try {
      const res = await fetch(`${origin}/api/0/checkExe/${search}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          module: "estBoring",
        }),
      });

      const json = await res.json();
      console.log("res", json);

      if (json.result === "OK") {
        return true; // 処理可能
      } else {
        this.props.dispatch(changeWaitngTimeAction(json.waiting_time));
        this.props.dispatch(changeInExeWaitngAction(true)); // GUI表示
        return false; // 待機状態
      }
    } catch (err) {
      console.log(err);
      alert("サーバーエラー");
      return false; // エラー時も止める
    }
  }

  render() {
    return (
      <div>
        <Sw title="複数井戸作成" focusName="wells">
          <div className="l-flex">
            <button className="sBtn" onClick={this.addSel}>
              追加
            </button>
            <button className="sBtn" onClick={this.deleteSel}>
              削除
            </button>
            <button className="sBtn" onClick={this.deleteAll}>
              全削除
            </button>
          </div>
          <div className="idoInput l-mtSSS" style={{ overflowY: "scroll" }}>
            <table className="idoTable">
              <thead>
                <tr>
                  <th className="tsS">ID</th>
                  <th className="tsS">種別</th>
                  <th className="tsS">緯度</th>
                  <th className="tsS">経度</th>
                  <th className="tsS">
                    揚水量(m<sup>3</sup>/d)
                  </th>
                  <th className="tsS">予測表示</th>
                </tr>
              </thead>
              <tbody ref={ref => (this.tbRef = ref)}>
                {this.props.wellsTrData !== undefined &&
                  this.props.wellsTrData.map((el, index) => (
                    <tr id={index} key={index} onClick={this.changeRow} onMouseEnter={() => this.hglBoring(index)} onMouseLeave={() => this.hglBoring(null)}>
                      <td>
                        <input className="textTR" type="text" defaultValue={el.ID} />
                      </td>
                      <td>
                        <select
                          className="selectF"
                          value={el.KIND} // ここで種別の値を指定
                          onChange={e => this.changeType(e, index)}>
                          <option value="type1">揚水井</option>
                          <option value="type2">還元井</option>
                        </select>
                      </td>
                      <td>
                        <input className="textTR" type="text" value={el.LAT} onChange={e => this.changeField(e, index, "LAT")} onBlur={e => this.checkField(e, index, "LAT", el.LON)} />
                      </td>
                      <td>
                        <input className="textTR" type="text" value={el.LON} onChange={e => this.changeField(e, index, "LON")} onBlur={e => this.checkField(e, index, "LON", el.LAT)} />
                      </td>
                      <td>
                        <input className="textTR" type="text" value={el.PA} onChange={e => this.changeField(e, index, "PA")} />
                      </td>
                      <td className="scrCheck">
                        <input type="checkbox" checked={this.state.selectedCheckbox === index} onChange={() => this.handleCheckboxClick(index)} />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <fieldset className="Unit l-mtS">
            <legend>説明</legend>
            <p>
              左クリック：井戸ポイント追加
              <br />
              ※井戸間の距離は{window.getLimitWellDist()}
              m以下にする必要があります。
              <br />
              ※予測を実行すると、設定したスクリーン位置がリセットされます。
              <br />
            </p>
          </fieldset>
          <div className="l-right l-mtS ">
            <button className="cBtn" onClick={this.doLearnPred}>
              予測
            </button>
          </div>
        </Sw>
        {this.props.estBorSw ? <EstBoring /> : null}
      </div>
    );
  }
}

export default connect(mapStateToProps)(RegionModelWindow);
